/**
 * https://developers.google.com/youtube/gaming/playables/reference/sdk
 *
 * Created by vladislav on 9/6/2022
 */

const Youtube = function () {
    this.audioEnabled = true;
    Platform.call(this, connector.YOUTUBE);
};

Youtube.prototype = Object.create(Platform.prototype);
Youtube.prototype.constructor = Youtube;

Youtube.prototype.getLocalStoragePrefix = function () {
    return "_nosocial";
};

Youtube.prototype.notifyGameReady = function () {
    if (typeof ytgame !== "undefined") {
        ytgame.game.gameReady();
    }
};

Youtube.prototype.startGame = function (callback) {
    connector.platform.whenConnected(() => {
        ytgame.game.firstFrameReady();
        callback();
    });
};

Youtube.prototype.hasAudioControls = function () {
    return true;
};

Youtube.prototype.isAudioEnabled = function () {
    return this.audioEnabled;
};

Youtube.prototype._initialize = function (callback) {
    if (ytgame.IN_PLAYABLES_ENV) {
        connector.dataLoader.localStorage = new YoutubeLocalStorage();
    }

    new ConnectorActionPlayer([
        (f) => {
            ytgame.system.onPause(() => this._toggleSdkPaused(true));
            ytgame.system.onResume(() => this._toggleSdkPaused(false));

            ytgame.system.getLanguage().then((lang) => {
                connector.info.language = lang.split("-")[0];
                f();
            }).catch(() => {
                f();
            });
        },

        (f) => {
            const updateAudio = (isEnabled) => {
                this.audioEnabled = isEnabled;
                this.bus.trigger("audioToggle", isEnabled);
            };
            updateAudio(ytgame.system.isAudioEnabled());
            ytgame.system.onAudioEnabledChange(updateAudio);

            f();
        }
    ]).play(callback);
};